<nav class="nav account-details-nav">
  <a class="nav-item" [routerLink]="['/account']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
    <label class="mb-0">{{ 'account.nav.profile' | translate }}</label>
  </a>
  <a class="nav-item" [routerLink]="['/activity']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
    <label class="mb-0">{{ 'account.nav.activity' | translate }}</label>
  </a>
</nav>
